import { useLocation } from 'react-router'
import routes, { getRouteFromPathname } from 'shared/routes'
import { setGTADataLayer } from 'shared/util/analytics'
import { CREATE } from '../../../site/gif-maker/components/route'

const GTALogger = () => {
    const { pathname }: Partial<Location> = useLocation()
    let value
    const isStickerDetail = pathname.indexOf('/stickers/') >= 0
    const isStickerSearch = pathname.indexOf('-sticker') >= 0
    const route = getRouteFromPathname(pathname)
    const CREATEROUTE = { path: CREATE }

    switch (route) {
        case routes.GIF_DETAIL:
            value = isStickerDetail ? 'StickerDetail' : 'GIFDetail'
            break
        case routes.UPLOAD:
            value = 'Upload'
            break
        case routes.CATEGORIES:
            value = 'Categories'
            break
        case CREATEROUTE:
            value = 'Create'
            break
        case routes.SEARCH:
            value = isStickerSearch ? 'StickerSearch' : 'GIFSearch'
            break
        case routes.SETTINGS:
            value = 'Settings'
            break
        case routes.FAVORITES:
            value = 'Favorites'
            break
        case routes.CHANNEL:
            value = 'Channel'
            break
        case routes.HOME:
            value = 'Home'
            break
        case routes.TEAM:
            value = 'Team'
            break
        case routes.EXPLORE:
            value = 'Explore'
            break
        default:
            value = '404'
            break
    }
    setGTADataLayer({ dimension: 'PageCategory', value })
    return null
}

export default GTALogger
